import
  React, {
  useEffect
} from 'react';

import
  PropTypes
from 'prop-types';

export const PaymentGatewayForm = (props) => {

  const formRef = React.useRef(null);

  const formInputsBuilder = (formInputObject) => {

    if (!formInputObject || typeof formInputObject !== 'object') {
      return [];
    }

    const formInputFields = [];

    for (const key in formInputObject) {

      if (formInputObject.hasOwnProperty(key)) {

        formInputFields.push({
          type: 'hidden',
          name: key,
          id: key,
          value: formInputObject[key]
        });
      }
    }

    return formInputFields;
  };

  useEffect(() => {

    if (!props.paymentDetails) {
      return;
    }

    formRef.current.action = props.paymentDetails?.paymentGatewayUrl;

    let fields = [];

    try {
      fields = formInputsBuilder(props.paymentDetails);
    } catch (e) {
      console.warn(e);
    }

    for (let i = 0; i < fields.length; i ++) {

      let inputElement = document.createElement('INPUT');
      inputElement.type = fields[i].type || 'HIDDEN';
      inputElement.name = fields[i].name;
      inputElement.id = fields[i].id;
      inputElement.value = fields[i].value;
      formRef.current.appendChild(inputElement);
    }

    formRef.current.submit();

  }, [ props.paymentDetails ]);

  return (

    <form
      ref={formRef}
      type={'hidden'}
      name={'VoucherAdvanceConnectU'}
      id={'VoucherAdvanceConnectU'}
      method={'post'}/>
  );
};

PaymentGatewayForm.propTypes = {
  paymentDetails: PropTypes.object
};

PaymentGatewayForm.defaultProps = {
  paymentDetails: null
};